<template>
    <el-select :value="value" class="select" clearable filterable :placeholder="$t('shared.pleaseSelectProduct')" v-bind:disabled="disabled" :loading="loading" @change="change">
        <el-option v-for="item in products" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    import api from './api'
    export default {
        name: 'product-selector',
        props: ['value', 'disabled'],
        data() {
            return {
                loading: false,
                products: []
            }
        },
        methods: {
            change(val) {
                this.$emit('input', val)

                var targetSerial = val ? this.products.find(p => p.id === val).serialPrefix : undefined;
                this.$emit('serialUpdate', targetSerial)
            }
        },
        created() {
            this.loading = true
            api.getProducts().then(response => {
                this.loading = false
                this.products = response.data
            })
        }
    }
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/productselector/ProductSelector.vue